"use client";

import { useEffect, useRef, useState } from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  roman: "I.",
  title: "Verifikasi Data — Akurasi Utama",
  italic: "Memastikan setiap fakta berdiri di atas kebenaran.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/verifikasi_data_redaksi.png",
  nextLabel: "BERIKUTNYA — CROSS CHECK",
  instructions: ["Validasi sumber informasi primer secara mendalam.", "Periksa kesesuaian data dengan dokumen resmi.", "Pastikan narasumber memiliki kredibilitas tinggi.", "Dokumentasikan setiap temuan awal dengan rapi."]
}, {
  roman: "II.",
  title: "Konfirmasi — Keseimbangan Berita",
  italic: "Memberikan ruang bagi setiap pihak untuk bersuara.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/konfirmasi_narasumber.png",
  nextLabel: "BERIKUTNYA — PENULISAN",
  instructions: ["Hubungi pihak terkait untuk mendapatkan klarifikasi.", "Terapkan prinsip check and re-check secara ketat.", "Hindari opini sepihak dalam pengumpulan bahan.", "Catat waktu dan respon dari setiap upaya konfirmasi."]
}, {
  roman: "III.",
  title: "Penulisan — Narasi Profesional",
  italic: "Menyusun kata menjadi informasi yang mencerahkan.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/penulisan_berita_nasional.png",
  nextLabel: "BERIKUTNYA — EDITING",
  instructions: ["Gunakan bahasa Indonesia yang baik dan benar.", "Susun struktur berita dengan piramida terbalik.", "Pastikan judul menarik namun tetap akurat.", "Sertakan latar belakang konteks yang relevan."]
}, {
  roman: "IV.",
  title: "Penyuntingan — Ketajaman Redaksi",
  italic: "Memoles naskah hingga mencapai standar kualitas.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/editing_redaksi_abadi.png",
  nextLabel: "BERIKUTNYA — LEGALITAS",
  instructions: ["Koreksi kesalahan tipografi dan tata bahasa.", "Pastikan tidak ada unsur SARA atau fitnah.", "Periksa kembali alur logika dalam setiap paragraf.", "Sesuaikan gaya penulisan dengan identitas ABADI.NEWS."]
}, {
  roman: "V.",
  title: "Uji Legalitas — Kepatuhan Hukum",
  italic: "Berjalan selaras dengan Pedoman Media Siber.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/legalitas_media_siber.png",
  nextLabel: "BERIKUTNYA — VISUAL",
  instructions: ["Pastikan konten tidak melanggar UU ITE.", "Verifikasi hak cipta pada gambar dan video.", "Konsultasikan isu sensitif dengan tim hukum.", "Jamin perlindungan terhadap identitas saksi."]
}, {
  roman: "VI.",
  title: "Kurasi Visual — Estetika Modern",
  italic: "Gambar yang bercerita lebih dari seribu kata.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kurasi_visual_berita.png",
  nextLabel: "BERIKUTNYA — LAYOUT",
  instructions: ["Pilih foto utama dengan resolusi tinggi.", "Berikan caption yang informatif dan akurat.", "Pastikan visual mendukung narasi berita.", "Optimasi ukuran gambar untuk kecepatan akses."]
}, {
  roman: "VII.",
  title: "Tata Letak — Kenyamanan Membaca",
  italic: "Ruang kosong adalah kunci fokus pembaca.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/layout_portal_berita.png",
  nextLabel: "BERIKUTNYA — OPTIMASI",
  instructions: ["Atur penempatan iklan agar tidak mengganggu.", "Gunakan tipografi yang mudah dibaca di mobile.", "Pastikan navigasi antar berita berjalan mulus.", "Terapkan desain bersih dengan aksen orange."]
}, {
  roman: "VIII.",
  title: "Optimasi SEO — Jangkauan Luas",
  italic: "Menghubungkan berita dengan pembaca yang tepat.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/seo_optimasi_news.png",
  nextLabel: "BERIKUTNYA — REVIEW AKHIR",
  instructions: ["Gunakan kata kunci yang relevan dan organik.", "Optimasi meta deskripsi untuk mesin pencari.", "Pastikan struktur URL bersih dan deskriptif.", "Tautkan dengan berita terkait secara internal."]
}, {
  roman: "IX.",
  title: "Review Akhir — Persetujuan Redaktur",
  italic: "Gerbang terakhir sebelum informasi mengudara.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/final_review_redaktur.png",
  nextLabel: "BERIKUTNYA — PUBLIKASI",
  instructions: ["Pengecekan menyeluruh oleh Redaktur Pelaksana.", "Pastikan semua elemen berita sudah lengkap.", "Konfirmasi ulang kesiapan teknis halaman.", "Berikan tanda persetujuan final publikasi."]
}, {
  roman: "X.",
  title: "Publikasi — Siaran Nasional",
  italic: "Menyebarkan kebenaran ke seluruh penjuru.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/publikasi_berita_online.png",
  nextLabel: "BERIKUTNYA — DISTRIBUSI",
  instructions: ["Tekan tombol publikasi pada sistem CMS.", "Pastikan berita muncul di halaman Beranda.", "Verifikasi tampilan di berbagai perangkat.", "Pantau respon awal dari para pembaca."]
}, {
  roman: "XI.",
  title: "Distribusi — Media Sosial",
  italic: "Membangun interaksi di ruang digital.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/distribusi_sosial_media.png",
  nextLabel: "BERIKUTNYA — MONITORING",
  instructions: ["Bagikan ke kanal resmi Facebook dan Instagram.", "Gunakan caption yang memicu diskusi sehat.", "Pantau statistik klik dan keterlibatan.", "Respon komentar pembaca secara profesional."]
}, {
  roman: "XII.",
  title: "Monitoring — Evaluasi Dampak",
  italic: "Belajar dari setiap berita yang disajikan.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/monitoring_evaluasi_redaksi.webp",
  nextLabel: "MULAI KEMBALI",
  instructions: ["Analisis data pembaca melalui dashboard.", "Evaluasi performa berita dalam rapat redaksi.", "Terima masukan dan kritik dari masyarakat.", "Terus tingkatkan standar jurnalisme ABADI."]
}];
function StepBlock({
  step,
  index,
  drift
}: {
  step: (typeof steps)[number];
  index: number;
  drift: "left" | "right";
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const words = step.italic.split(" ");
  return <div data-index={index} ref={ref} data-step-index={index} className={`min-h-[80vh] flex flex-col justify-center scroll-mt-24 ${drift === "right" ? "md:ml-auto md:mr-0" : "md:ml-0 md:mr-auto"} md:max-w-[92%]`}>
      <div className="flex items-baseline gap-6 mb-8">
        <span className={`font-serif text-6xl md:text-7xl lg:text-8xl text-primary leading-none transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {step.roman}
        </span>
        <span className="font-mono text-xs tracking-widest uppercase text-muted-foreground">
          Tahap {String(index + 1).padStart(2, "0")} dari 12
        </span>
      </div>

      <h3 className={`font-default font-bold text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground mb-10 max-w-2xl transition-all duration-1000 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {step.title}
      </h3>

      <div className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 items-start ${drift === "right" ? "md:[direction:rtl]" : ""}`}>
        <div className={`md:col-span-7 ${drift === "right" ? "md:[direction:ltr]" : ""}`}>
          <div className={`overflow-hidden rounded-lg bg-muted shadow-md transition-all duration-1000 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-[0.98]"}`}>
            <img src={step.image} data-wvc-srcset={`${step.image}-wvc-srcset`} data-wvc-sizes={`${step.image}-wvc-sizes`} alt={step.title} loading="lazy" decoding="async" className="w-full aspect-[4/5] object-cover" />
          </div>
        </div>

        <div className={`md:col-span-5 flex flex-col gap-8 ${drift === "right" ? "md:[direction:ltr]" : ""}`}>
          <p className="font-serif italic text-xl md:text-2xl leading-relaxed text-foreground/85">
            {words.map((word, wi) => <span key={wi} className={`inline-block transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-3 blur-sm"}`} style={{
            transitionDelay: `${200 + wi * 60}ms`
          }}>
                {word}&nbsp;
              </span>)}
          </p>

          <ol className="flex flex-col gap-3">
            {step.instructions.map((line, li) => <li key={li} data-index={li} className={`flex gap-4 font-default text-sm md:text-[15px] leading-relaxed text-foreground/80 transition-all duration-700 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-3"}`} style={{
            transitionDelay: `${500 + li * 100}ms`
          }}>
                <span className="font-mono text-xs text-primary font-bold tracking-wider pt-1 shrink-0">
                  {String(li + 1).padStart(2, "0")}
                </span>
                <span>{line}</span>
              </li>)}
          </ol>
        </div>
      </div>

      <div className="mt-16 flex items-center gap-6">
        <Separator className="flex-1 bg-border" />
        <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
          {step.nextLabel}
        </span>
        <Separator className="flex-1 bg-border" />
      </div>
    </div>;
}
export default function Statusverifikasiredaksi() {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [activeStep, setActiveStep] = useState(0);
  const [progress, setProgress] = useState(0);
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      if (!container) return;
      const rect = container.getBoundingClientRect();
      const total = container.offsetHeight - window.innerHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      const ratio = total > 0 ? scrolled / total : 0;
      setProgress(Math.min(100, Math.max(0, ratio * 100)));
      const blocks = container.querySelectorAll<HTMLDivElement>("[data-step-index]");
      let current = 0;
      const anchor = window.innerHeight * 0.45;
      blocks.forEach(block => {
        const r = block.getBoundingClientRect();
        if (r.top <= anchor) {
          current = Number(block.dataset.stepIndex || 0);
        }
      });
      setActiveStep(current);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);
  const headlineWords = "Standar Verifikasi Redaksi".split(" ");
  return <section data-section-id="3877" id="statusverifikasiredaksi" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div ref={headerRef} className="text-center max-w-3xl mx-auto mb-24 md:mb-32">
          <span className={`inline-block font-mono text-[11px] tracking-[0.3em] uppercase text-primary font-bold mb-8 transition-all duration-700 ${headerVisible ? "opacity-100" : "opacity-0"}`}>
            — Proses Kami —
          </span>

          <h2 className="font-default font-bold text-5xl md:text-7xl lg:text-8xl tracking-tight text-foreground mb-8">
            {headlineWords.map((w, i) => <span key={i} className={`inline-block transition-all duration-1000 ${headerVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-6 blur-sm"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {w}&nbsp;
              </span>)}
          </h2>

          <p className={`font-serif italic text-xl md:text-2xl text-foreground/75 leading-relaxed transition-all duration-1000 delay-500 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Dalam dua belas langkah, kebenaran disajikan.
          </p>
        </div>

        <div ref={containerRef} className="grid grid-cols-12 gap-6 md:gap-10">
          <aside className="hidden md:block col-span-3 lg:col-span-2">
            <div className="sticky top-32 flex flex-col items-start gap-6">
              <div className="flex items-baseline gap-2">
                <span className="font-default font-bold text-5xl lg:text-6xl text-primary leading-none tabular-nums">
                  {String(activeStep + 1).padStart(2, "0")}
                </span>
                <span className="font-mono text-sm text-muted-foreground">
                  / 12
                </span>
              </div>

              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-secondary font-bold">
                Tahap Aktif
              </span>

              <div className="relative h-72 w-px bg-border mt-4 overflow-hidden rounded-md">
                <div className="absolute top-0 left-0 w-full bg-primary transition-all duration-300 ease-out" style={{
                height: `${progress}%`
              }} />
              </div>

              <div className="flex flex-col gap-2 mt-4">
                <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
                  Progres
                </span>
                <span className="font-mono text-xs text-foreground font-bold tabular-nums">
                  {Math.round(progress)}%
                </span>
              </div>

              <p className="font-serif italic text-sm text-foreground/60 max-w-[10rem] mt-4 leading-relaxed">
                Alur kerja profesional — menjaga integritas di setiap lapisan.
              </p>
            </div>
          </aside>

          <div className="md:hidden col-span-12 sticky top-20 z-10 bg-background/95 backdrop-blur-sm py-4 -mx-6 px-6 border-b border-border">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-baseline gap-2">
                <span className="font-default font-bold text-2xl text-primary tabular-nums">
                  {String(activeStep + 1).padStart(2, "0")}
                </span>
                <span className="font-mono text-xs text-muted-foreground">
                  / 12
                </span>
              </div>
              <div className="flex-1 h-px bg-border relative overflow-hidden rounded-md">
                <div className="absolute top-0 left-0 h-full bg-primary transition-all duration-300" style={{
                width: `${progress}%`
              }} />
              </div>
              <span className="font-mono text-[10px] text-muted-foreground tabular-nums">
                {Math.round(progress)}%
              </span>
            </div>
          </div>

          <div className="col-span-12 md:col-span-9 lg:col-span-10 md:col-start-4 lg:col-start-3 flex flex-col gap-16 md:gap-24">
            {steps.map((step, i) => <StepBlock key={i} step={step} index={i} drift={i % 2 === 0 ? "left" : "right"} />)}
          </div>
        </div>
      </div>
    </section>;
}